import { Page } from '@components/layout/Page';
import { HomePageProps } from './HomePage.types';
import { HomeLogin } from './login';
import { HomeOffers } from './offers';

export const HomePage: React.FC<HomePageProps> = ({ user, offers, total, page, size }) => {
  return (
    <Page user={user} pageId="offers">
      {user ? (
        <HomeOffers
          offers={offers || []}
          total={total ?? 0}
          page={page ?? 1}
          size={size ?? 10}
        />
      ) : (
        <HomeLogin />
      )}
    </Page>
  );
};
